const MoonSvg = ({
  height = 16,
  width = 16,
  viewBox = '0 0 16 16',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M5.5 2.96069C5.5 6.68862 8.52208 9.71069 12.25 9.71069C12.9319 9.71069 13.5903 9.60983 14.2108 9.42175C13.3707 12.1934 10.796 14.2106 7.75 14.2106C4.02208 14.2106 1 11.1887 1 7.4608C1 4.41482 3.01756 1.84007 5.7892 1C5.60113 1.62053 5.5 2.27875 5.5 2.96069Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default MoonSvg;
